import routes from "routes/routes";
import { ORGANIZATION_ID_PARAM } from "./organizationAdmin";
import type { HallTime } from "api/account/types";

/** "Our hall times" (W2-1). Same URL-restore rule as the plan. */
export const makeOrganizationHallTimesPath = (organizationId: string): string =>
  routes.accountOrganizationHallTimesPath.replace(
    `:${ORGANIZATION_ID_PARAM}`,
    encodeURIComponent(organizationId)
  );

/** How many weeks the page shows first, how many more each time, and at most (the server's cap). */
export const FIRST_WEEKS = 8;
export const MORE_WEEKS = 8;
export const MAX_WEEKS = 26;

export type HallTimeAction = "release" | "restore";

/**
 * What an owner may do with a date: nothing once it has started (Q7 A), and
 * nothing on a holiday the window pauses on (D7) — that time is not theirs.
 */
export const hallTimeAction = (time: HallTime): HallTimeAction | null => {
  if (time.started || time.paused) return null;
  return time.released ? "restore" : "release";
};

/**
 * The message key for a refused release or restore — every cause told apart,
 * from the code the admin service sends (`windowReleases.ts`).
 */
export const hallTimeFailureKey = (status: number | string | undefined, code: string | undefined): string => {
  switch (code) {
    case "booked":
      return "error_booked";
    case "released_time_booked":
      return "error_released_time_booked";
    case "release_started":
      return "error_started";
    case "release_not_an_occurrence":
    case "window_not_found":
      return "error_changed";
    default:
      break;
  }
  switch (status) {
    case 404:
      return "error_not_allowed";
    case 504:
      return "error_timeout";
    case 502:
    case 503:
      return "error_unavailable";
    default:
      return "error_generic";
  }
};
